import { createFileRoute, notFound } from "@tanstack/react-router";

import { LeadMagnetView } from "@/components/pages/LeadMagnetView";
import { landingMagnets } from "@/content/landing-magnets";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/travel-scan")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/travel-scan",
          ...landingMagnets[params.locale].travelScan.meta,
          smartBanner: true,
        })
      : {},
  component: TravelScanRoute,
});

function TravelScanRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return <LeadMagnetView locale={locale} page="travelScan" />;
}
